import { useState } from "react";
import { User } from "../models/user.model";
import './login.component.css';
import securityService from "../services/security.service";
import { LoginUserPwd } from "../models/loginuserpwd.model";

interface LoginProps { 
    loginOk: (user:User | null) => void;
}

function LoginComponent(props:LoginProps) { 
  const [error, setError] = useState(false);
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
 
  const handleUserIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserId(e.target.value);
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  const handleSubmit = () => {
    setError(false);
    const userPwd:LoginUserPwd = {
      username: userId,
      password: password
    };
    securityService.authenticate(userPwd)
                    .then(token => {
                      securityService.authenticatedUser()
                        .then( u => props.loginOk(u));
                    })
                    .catch(err => {
                      console.log('err : ' + err);
                      setError(true);
                    });
  } 

  return (
    <>
        <div className="login-form">
          <p>Login</p>

          <div>
            <div>User ID</div>
            <input type="text" value={userId} onChange={handleUserIdChange}></input>
          </div>

          <div>
            <div>Password</div>
            <input type="password" value={password} onChange={handlePasswordChange}></input>
          </div>

          {error ? <div className="errorMsg">Error</div> : null}
        
          <div>
                <button onClick={handleSubmit}>Login</button>
          </div>
        </div>
    </>
  );
   
  } 
export default LoginComponent;